import React from 'react';
import {
  Paper,
  Typography,
  Button
} from '@mui/material';
import { Star } from '@mui/icons-material';

const FavoritesTab = () => {
  return (
    <Paper 
      elevation={2} 
      sx={{ 
        p: 4, 
        textAlign: 'center', 
        minHeight: 400, 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center' 
      }}
    >
      <Star sx={{ fontSize: 80, color: 'warning.main', mb: 2 }} />
      <Typography variant="h4" gutterBottom>
        Favorites Coming Soon
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Your favorite properties will appear here for quick access and tracking.
      </Typography>
      <Button variant="outlined" color="primary" size="large">
        Browse Properties
      </Button>
    </Paper>
  );
};

export default FavoritesTab; 